// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"117":"ca79e1b2","136":"f664358a","151":"786de462","991":"5f2af927"}[chunkId] || chunkId) + "." + {"117":"47270746077fd869","133":"469ffd2d24c158f0","136":"356b6a40c93b1b85","151":"c1b7cd9f4033e212","230":"37466cf7d655c54e","991":"ea20b3b3e84792d0"}[chunkId] + ".js";
};